export class NotesService {
  constructor (API, $timeout) {
    'ngInject';

    this.$timeout = $timeout;
    this.API = API;
    this.notes = [];
    this.NOTE_DISAPPEARS_AFTER_MS = 5000;
  }

  postNote(note){
    note.active = true;
    note.id = (Math.random()*1000000000000000).toFixed(0);
    this.notes.push(note);

    if (!note.manualHide)
      this.$timeout(() => {
        note.active = false;
        this.$timeout(() => {note.hidden = true;}, note.disappearAfter || this.NOTE_DISAPPEARS_AFTER_MS);
      }, note.disappearAfter || this.NOTE_DISAPPEARS_AFTER_MS);

  }

  getNotes(){
    return this.notes;
  }

  hide(note) {
    this.notes.filter((x) => x.id == note.id).map((x) => x.active = false);
  }
}
